import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    message: { type: String, default: "Tem certeza?" },
    confirm: { type: String, default: "Confirmar" },
    cancel: { type: String, default: "Cancelar" },
    title: { type: String, default: "Confirmação" },
    method: { type: String, default: "post" },
  }

  confirm(event) {
    event.preventDefault()
    const url = this.element.getAttribute("href") || this.element.action
    const form = this.element.closest("form")

    Swal.fire({
      title: this.titleValue,
      text: this.messageValue,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#16a34a",
      cancelButtonColor: "#6b7280",
      confirmButtonText: this.confirmValue,
      cancelButtonText: this.cancelValue,
    }).then((result) => {
      if (result.isConfirmed) {
        if (form) {
          form.submit()
        } else if (url) {
          this.#submitViaTurbo(url)
        }
      }
    })
  }

  #submitViaTurbo(url) {
    const csrfToken = document.querySelector("[name='csrf-token']")?.content
    fetch(url, {
      method: this.methodValue,
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
      },
    }).then(() => {
      window.location.reload()
    })
  }
}
